// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__+o6ll","active":"Modal_active__4hvex","modal__content":"Modal_modal__content__1zkGS"};